import fuentesTypes from '../actions/fuentesabiertas.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        case fuentesTypes.STORE_FUENTES:
            return {
                ...state,
                fuentes: action.payload,
                status: 'LOADED'
            }

        case fuentesTypes.CLEAR_FUENTES:
            return {
                fuentes: []
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    fuentes: []
};